// Types
import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

function useStateWithReset<TState>(
    defaultValue: TState = null
): [TState, Dispatch<SetStateAction<TState>>, () => void] {
    const [state, setState] = useState<TState>(defaultValue);

    const resetState = () => setState(defaultValue);

    return [state, setState, resetState];
}

export default useStateWithReset;
